import './MovementNotesPhotos.scss';
import PropTypes from 'prop-types';
import NoteList from '../NoteList/NoteList';
import PhotoList from '../PhotoList/PhotoList';
import Notes from '../../api/controllers/Notes/Notes';
import Attachment from '../../api/controllers/Attachment/Attachment';
import { useEffect, useState } from 'react';
import Modal from '../Modal/Modal';
import AddNote from '../AddNote/AddNote';
import AddPhoto from '../AddPhoto/AddPhoto';
import Button from '../Button/Button';

// MovementNotesPhotos Screen Component
const MovementNotesPhotos = ({ setError, movement, movementType, setDamaged, completed }) => {
  const [notes, setNotes] = useState();
  const [attachments, setAttachments] = useState();
  const [modalOpen, setModalOpen] = useState();

  const getModalTitle = () => {
    switch (modalOpen) {
      case 'add_note':
        return 'Add Note';
      case 'add_photo':
        return 'Photo';
    }
  };

  const getModalType = () => {
    switch (modalOpen) {
      case 'add_note':
        return (
          <AddNote
            refetchNotes={getNotes}
            setModalOpen={setModalOpen}
            movementType={movementType}
            modelName={movement?.modelName}
            movementId={movement.id}
          />
        );
      case 'add_photo':
        return (
          <AddPhoto
            refetchPhotos={getAttachments}
            setModalOpen={setModalOpen}
            modelName={movement?.modelName}
            movementId={movement.id}
          />
        );
    }
  };

  const getNotes = () => {
    Notes.all({ parentType: movement?.modelName, parentId: movement?.id })
      .then(response => {
        setNotes(response.items);
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  const getAttachments = () => {
    Attachment.all({ parentType: movement?.modelName, parentId: movement?.id, photos: true })
      .then(response => {
        setAttachments(response.items);
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  useEffect(() => {
    if (movement) {
      getNotes();
      getAttachments();
    }
  }, [movement]);

  useEffect(() => {
    if (setDamaged) {
      if (attachments && attachments.some(a => a.classification == 'damaged_consignment_photo')) {
        setDamaged(true);
      } else {
        setDamaged(false);
      }
    }
  }, [attachments]);

  return (
    <>
      {!completed && (
        <div className="movement_notes_photos">
          <Button
            className="notes_photos_button"
            onClick={() => setModalOpen('add_photo')}
            label="Attach photo"
          />
          <Button
            className="notes_photos_button"
            onClick={() => setModalOpen('add_note')}
            label="Add note"
          />
        </div>
      )}
      {(notes?.length > 0 || attachments?.length > 0) && (
        <div className="movement_notes_photos_lists">
          <PhotoList
            photos={attachments}
            refetchPhotos={getAttachments}
            modelName={movement?.modelName}
            setError={setError}
            completed={completed}
          />
          <NoteList
            notes={notes}
            refetchNotes={getNotes}
            modelName={movement?.modelName}
            movementType={movementType}
            completed={completed}
          />
        </div>
      )}
      {modalOpen && (
        <Modal title={getModalTitle()} content={getModalType()} setModalOpen={setModalOpen} />
      )}
    </>
  );
};

MovementNotesPhotos.propTypes = {
  setError: PropTypes.func,
  movement: PropTypes.object,
  movementType: PropTypes.string,
  setDamaged: PropTypes.func,
  completed: PropTypes.bool,
};

export default MovementNotesPhotos;
